import store from '../../store'
import admin from './admin'
import user from './user'
import window from './window'
import publicRoute from './public'
import Company from '@/models/Company'
import User from '@/models/User'
import UserHelper from '@/helpers/user'

export default [
  {
    path: '/',
    name: 'home',
    component: () => import('@/layouts/full-page/FullPage.vue'),
    redirect: { name: 'login' },
    children: [
      {
        path: 'login',
        name: 'login',
        component: () => import('@/views/Login.vue'),
        beforeEnter: (to, from, next) => {
          document.querySelector('body').classList.add('kt-page--login')

          if (store.getters.token) {
            if (store.getters.isAdmin) {
              next({ name: 'admin.dashboard' })
            } else {
              next({ name: 'dashboard' })
            }
          } else next()
        },
        beforeRouteLeave: (to, from, next) => {
          next()
        }
      },
      {
        path: '/404',
        name: 'notfound',
        component: () => import('@/views/Error404.vue')
      }
    ]
  },
  ...(function () {
    const guard = [
      ...user,
      ...admin,
      ...window,
      ...publicRoute
    ]
    guard.forEach((v) => {
      v.beforeEnter = (to, from, next) => {
        const segments = to.fullPath.split('/')

        if (segments[1] === 'public') {
          next()
        } else {
          if (to.query.apiKey !== undefined) {

            Company.loginViaApiKey(to.query.apiKey).then(function (response) {
              const userData = new UserHelper(response)
              store.dispatch('setToken', userData.getAccessToken())
              store.dispatch('setRefreshToken', userData.getRefreshToken())
              store.dispatch('setUserInfo', userData.getUserData())

              if (!store.getters.token) {
                next({ name: 'login' })
              } else next()

            }, function () {

              if (!store.getters.token) {
                next({ name: 'login' })
              } else {
                next()
              }

            })

          } else if (to.query.agentApiKey !== undefined) {

            User.loginViaApiKey(to.query.agentApiKey).then(function (response) {
              const userData = new UserHelper(response)
              store.dispatch('setToken', userData.getAccessToken())
              store.dispatch('setRefreshToken', userData.getRefreshToken())
              store.dispatch('setUserInfo', userData.getUserData())

              if (!store.getters.token) {
                next({ name: 'login' })
              } else next()

            }, function () {

              if (!store.getters.token) {
                next({ name: 'login' })
              } else {
                next()
              }

            })

          } else {

            if (!store.getters.token) {
              next({ name: 'login' })
            }
            next()

          }
        }
      }
    })

    return guard
  })(),
  // Redirect to 404 page, if no match found
  {
    path: '*',
    redirect: { name: 'notfound' }
  }
]
